// extracted by mini-css-extract-plugin
var _1 = "qzTys";
var _2 = "q__p9";
export { _1 as "categoryList", _2 as "subHeader" }
